import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import isAdmin from 'utils/session/isAdmin';
import EmptyStateController from 'components/EmptyStateController';
import NumberGrid from 'components/NumberGrid';
import Sparkline from 'components/Sparkline';
import VisuallyHidden from 'components/VisuallyHidden';
import { Option, Select } from 'components/Select';
import { StatsWrapper } from 'components/InlineStatsPanel';
import { useFetchPlaylistAnalytics } from 'actions/playlists';
import { useFetchAssetAnalytics } from 'actions/assets';
import Box from 'components/Box';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SparkPanel = function SparkPanel(_ref) {
  var _analytics$data;
  var id = _ref.id,
    type = _ref.type,
    title = _ref.title,
    hideGraph = _ref.hideGraph,
    xaxis = _ref.xaxis,
    _ref$isPanelLayout = _ref.isPanelLayout,
    isPanelLayout = _ref$isPanelLayout === void 0 ? false : _ref$isPanelLayout;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState('30'),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTimeframe = _useState2[0],
    setSelectedTimeframe = _useState2[1];
  var _useFetchPlaylistAnal = useFetchPlaylistAnalytics({
      playlistId: id,
      period: selectedTimeframe,
      enabled: type === 'playlist' && isAdmin()
    }),
    playlistLoading = _useFetchPlaylistAnal.isLoading,
    playlistError = _useFetchPlaylistAnal.isError,
    playlistAnalytics = _useFetchPlaylistAnal.data;
  var _useFetchAssetAnalyti = useFetchAssetAnalytics({
      assetId: id,
      period: selectedTimeframe,
      enabled: type !== 'playlist' && isAdmin(),
      assetType: type
    }),
    assetLoading = _useFetchAssetAnalyti.isLoading,
    assetError = _useFetchAssetAnalyti.isError,
    assetAnalytics = _useFetchAssetAnalyti.data;
  var isLoading = playlistLoading || assetLoading;
  var isError = playlistError || assetError;
  var analytics = type === 'playlist' ? playlistAnalytics : assetAnalytics;
  var timeSelectorButton = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(VisuallyHidden, {
      as: "label",
      id: "timeframe_select_label",
      children: t('property_metrics_time_frame')
    }), /*#__PURE__*/_jsxs(Select, {
      variant: isPanelLayout ? 'transparent' : 'default',
      size: isPanelLayout ? 'small' : 'medium',
      labelledById: "timeframe_select_label",
      value: selectedTimeframe,
      onChange: function onChange(newTimeFrame) {
        return setSelectedTimeframe(newTimeFrame);
      },
      children: [/*#__PURE__*/_jsx(Option, {
        value: "7",
        children: t('analytics_last_7_days')
      }), /*#__PURE__*/_jsx(Option, {
        value: "30",
        children: t('analytics_last_30_days')
      }), /*#__PURE__*/_jsx(Option, {
        value: "365",
        children: t('analytics_last_12_months')
      })]
    })]
  });
  return /*#__PURE__*/_jsx(StatsWrapper, {
    title: title,
    actions: !hideGraph ? timeSelectorButton : null,
    isPanelLayout: isPanelLayout,
    children: /*#__PURE__*/_jsxs(EmptyStateController, {
      isLoading: isLoading,
      isEmpty: isError || !(analytics !== null && analytics !== void 0 && (_analytics$data = analytics.data) !== null && _analytics$data !== void 0 && _analytics$data.length),
      isError: isError,
      children: [/*#__PURE__*/_jsx(NumberGrid, {
        data: analytics === null || analytics === void 0 ? void 0 : analytics.data
      }), !hideGraph && /*#__PURE__*/_jsx(Box, {
        mt: "m",
        children: /*#__PURE__*/_jsx(Sparkline, {
          data: (analytics === null || analytics === void 0 ? void 0 : analytics.history) || [],
          period: selectedTimeframe,
          name: xaxis || t('actions_opened'),
          legend: xaxis || t('actions_opened')
        })
      })]
    })
  });
};
export default SparkPanel;